<template>
    <div>
        <van-nav-bar
            title="我的预约"
            left-text="返回"
            left-arrow
            @click-left="clickback"
            @click-right="create"
        >
        <template #right>
            <van-icon name="plus" size="18" />
        </template>
        </van-nav-bar>
        <!-- <van-loading vertical v-if="loading"/> -->
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <van-cell center  size="large" v-for="item in dataList" :key="item.id" :title="item.shop_name" @click="toDetail(item.id)">
                <template slot="label" >
                    <span class="span_class">{{"时间："}}{{item.start_time | moment("YYYY-MM-DD")}} {{item.start_time|moment('HH:mm')}}-{{item.end_time|moment('HH:mm')}}</span>
                    <span class="span_class">{{"项目："}}{{item.project_name}}</span>
                    <span class="span_class">{{"车辆："}}{{(item.code_no?item.code_no:'')+(item.car_detail?item.car_detail.carcategory_name:'')}}</span>
                </template>
                <template slot="default" >
                    <span v-if="item.state==1" style="display:block;color:blue;">{{item.status}}</span>
                    <span v-else-if="item.state==2" style="display:block;color:#ffcc00;">{{item.status}}</span>
                    <span v-else style="display:block;color:red;">{{item.status}}</span>
                </template>
            </van-cell>
        </van-list>
    </div>
</template>

<script>
import { NavBar, Icon, Cell, List } from 'vant';
import { BookingApi } from '@/api/vip'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Cell.name]: Cell,
        // [Loading.name]: Loading,
        [List.name]: List
    },
    data() {
        return {
            dataList: [],
            loading: false,
            finished: false,
            query: {
                page: 0
            },
        }
    },
    mounted(){
    },
    methods: {
         onLoad() {
             this.query.page+=1
             this.getBooking()
         },
        getBooking(){
            var that = this
            that.axios.get(BookingApi, {params: that.query}).then((ret) => {
                that.loading = false
                ret.results.forEach(item => {
                    this.dataList.push(item)
                })
                if (ret.results == null || ret.results.length ===0 || ret.next == null) {
                    that.finished = true
                    return
                 }
            })
        },
        create(){
            this.$router.push(`/nt/user/bookingcreate`)
        },
        toDetail(id){
            this.$router.push(`/nt/user/bookingdetail/${id}`)
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/membercentre`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.span_class{
    display:block;
    width: 150%;
}
</style>